import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PulseLoader } from "react-spinners";
import { getPostReactions } from "../../functions/post";

export default function ReactionsModal({
  postId,
  token,
  setShowModal,
  selectedType,
  reacts,
  total,
}) {
  const [loading, setLoading] = useState(true);
  const [reactions, setReactions] = useState([]);
  const [activeTab, setActiveTab] = useState(selectedType || "all");
  const [filteredReactions, setFilteredReactions] = useState([]);

  useEffect(() => {
    loadReactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [postId]);

  useEffect(() => {
    if (activeTab === "all") {
      setFilteredReactions(reactions);
    } else {
      setFilteredReactions(reactions.filter((r) => r.react === activeTab));
    }
  }, [activeTab, reactions]);

  const loadReactions = async () => {
    setLoading(true);
    const res = await getPostReactions(postId, token);
    if (res.status === "ok") {
      setReactions(res.data);
    }
    setLoading(false);
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      setShowModal(false);
    }
  };

  const getReactCounts = () => {
    const counts = {};
    reactions.forEach((r) => {
      counts[r.react] = (counts[r.react] || 0) + 1;
    });
    return counts;
  };

  const reactCounts = getReactCounts();
  const availableReacts = Object.keys(reactCounts).sort(
    (a, b) => reactCounts[b] - reactCounts[a]
  );

  return (
    <div className="reactions_modal_overlay" onClick={handleBackdropClick}>
      <div className="reactions_modal">
        <div className="reactions_modal_header">
          <h3>People who reacted</h3>
          <button
            className="reactions_modal_close"
            onClick={() => setShowModal(false)}
          >
            <i className="exit_icon"></i>
          </button>
        </div>

        {/* Tabs */}
        <div className="reactions_tabs">
          <button
            className={`reaction_tab ${activeTab === "all" ? "active" : ""}`}
            onClick={() => setActiveTab("all")}
          >
            All {reactions.length}
          </button>
          {availableReacts.map((react) => (
            <button
              key={react}
              className={`reaction_tab ${activeTab === react ? "active" : ""}`}
              onClick={() => setActiveTab(react)}
            >
              <img src={`../../../reacts/${react}.svg`} alt={react} />
              {reactCounts[react]}
            </button>
          ))}
        </div>

        {/* Reactions List */}
        <div className="reactions_list">
          {loading ? (
            <div className="reactions_loading">
              <PulseLoader color="#1876f2" size={10} />
            </div>
          ) : filteredReactions.length === 0 ? (
            <div className="no_reactions">No reactions yet</div>
          ) : (
            filteredReactions.map((reaction) => (
              <div key={reaction.user._id} className="reaction_user_item">
                <div className="reaction_user_img_wrap">
                  <Link to={`/profile/${reaction.user.username}`}>
                    <img
                      src={reaction.user.picture}
                      alt=""
                      className="reaction_user_img"
                    />
                  </Link>
                  <img
                    src={`../../../reacts/${reaction.react}.svg`}
                    alt={reaction.react}
                    className="reaction_user_type"
                  />
                </div>
                <div className="reaction_user_info">
                  <Link
                    to={`/profile/${reaction.user.username}`}
                    className="reaction_user_name"
                  >
                    {reaction.user.first_name} {reaction.user.last_name}
                  </Link>
                  {reaction.mutualFriends > 0 && (
                    <span className="reaction_user_mutual">
                      {reaction.mutualFriends} mutual friend
                      {reaction.mutualFriends > 1 ? "s" : ""}
                    </span>
                  )}
                </div>
                {reaction.friendStatus === "friends" ? (
                  <button className="reaction_user_action">
                    <i className="friends_icon"></i>
                  </button>
                ) : reaction.friendStatus === "pending" ? (
                  <button className="reaction_user_action">Pending</button>
                ) : reaction.friendStatus === "self" ? null : (
                  <button className="reaction_user_action primary">
                    Add Friend
                  </button>
                )}
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
